module.exports = __webpack_public_path__ + "static/img/quanjing_01.19dd0ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quanjing_01.png
// module id = xVsN
// module chunks = 1